<ng-container *ngIf="persona">
  <div class="mx-auto text-center">
    <div class="max-w-200 mx-auto mb-16">
      <img
        class="aspect-square object-contain rounded-full"
        height="200"
        width="200"
        [src]="persona.profilePicture ? persona.profilePicture : '/assets/images/persona.png'"
      />
    </div>
    <div class="mb-16">
      <h3 class="mb-4 h5 text-orange">
        {{ persona.firstName }} {{ persona.lastName }}
      </h3>
      <p class="p">
        {{ persona.title }}
      </p>
    </div>
    <ng-container *ngIf="persona.links">
      <app-social-links [links]="persona.links"></app-social-links>
    </ng-container>
  </div>
</ng-container>
